import React, {useState, useEffect} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {useSelector, useDispatch} from 'react-redux'
import {toggleMenu} from '../../../store/actions/MenuAction'
import Logout from '../../common/Logout';
import {getUriRef} from '../../common/Utils'

function LeftBar() {
    const dispatch = useDispatch();
    const [logout, showLogout] = useState(false)
    const location = useLocation()
    const userData = useSelector(state => state.userCredentials)

    const menuVal = useSelector((state) => {
        return state.bar_controller;
    });
    const [urlId, seturiRef] = useState();
    const navigate = useNavigate();

    const LogoutAction = () => {
        showLogout(true);
    }

    useEffect(() => {
        let uri = location.pathname.replace('/', '')
        const uriRef = getUriRef(uri);
        seturiRef(uriRef)
    }, []);

    const links = [
        {
            id: 2,
            url: "/verify",
            label: "Farmer Purchase",
            visible: true,
            user: "agrodealer"
        },
        {
            id: 5,
            url: "/transactions",
            label: "View Transactions",
            visible: true,
            user: "agrodealer"
        },
        {
            id: 6,
            url: "/admin-dashboard",
            label: "Dashboard",
            visible: false,
            user: "admin"
        }
    ]


    const [activeLink, setActiveLink] = useState(1);

    function toggleBar() {
        dispatch(toggleMenu('hidden'))
    }

    return (
        <div className={`left_bar ${menuVal.value}`}>
            <Logout logout={logout} showLogout={showLogout} />
            <div className="left_bar_header">
                <p className="left_bar_header_logged_in">Logged in as:</p>
                <p className="left_bar_header_logged_name">{userData.username}</p>
                <button className="header_portal_menu" onClick={toggleBar}>
                    <svg width="25" height="25" id="icon-menu" viewBox="0 0 24 24">
                        <path fill="#fff"
                            d="M21 11.016v1.969h-14.156l3.563 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.563 3.609h14.156z"></path>
                    </svg>
                </button>
            </div>
            <div className="left_bar_mapper">
                {links.map((link, i) => (
                    <nav key={i} className="left_bar_nav">
                        {link.visible && userData.Type !== "ADMIN" && (
                            <ul className="left_bar_nav_ul" onClick={() => {
                                toggleBar();
                                navigate(link.url);
                                setActiveLink(link.id);
                            }}>
                                <li className={`left_bar_nav_ul_li ${urlId === link.id ? 'active' : ''}`}>
                                    <span className="left_bar_nav_ul_li_a">{link.label}</span>
                                </li>
                            </ul>
                        )}
                        {(link.user === "admin" && userData.Type === "ADMIN") && (
                            <ul className="left_bar_nav_ul" onClick={() => {
                                toggleBar();
                                navigate(link.url);
                                setActiveLink(link.id);
                            }}>
                                <li className={`left_bar_nav_ul_li ${urlId === link.id ? 'active' : ''}`}>
                                    <span className="left_bar_nav_ul_li_a">{link.label}</span>
                                </li>
                            </ul>
                        )}
                    </nav>
                ))}

                <button className="header_logout_btn" onClick={LogoutAction}>
                    <svg id="icon-logout" width="25" height="25" viewBox="0 0 24 24">
                        <path
                            d="M3.984 5.016v13.969h8.016v2.016h-8.016q-0.797 0-1.383-0.609t-0.586-1.406v-13.969q0-0.797 0.586-1.406t1.383-0.609h8.016v2.016h-8.016zM17.016 6.984l4.969 5.016-4.969 5.016-1.406-1.453 2.578-2.578h-10.172v-1.969h10.172l-2.578-2.625z"></path>
                    </svg>
                    Logout
                </button>
            </div>
        </div>
    );
}

export default LeftBar;
